export default "__VITE_ASSET__9Yx6_BDx__"